
<div class="filters-row" style="display: flex;  gap: 16px" [ngStyle]="styleVars">
  <div class="filter-container">
    <!-- Widget label ("Region", "Segment", …) shown above the control in EVERY
         display mode. Text: data.name (builder Display label / title / field),
         falling back to data.key for widgets saved before `name` existed.
         data.showLabel === false (Format popup) hides it; data.mandatory === true
         (Format popup "Mandatory") appends the red * marker. -->
    <label class="filter-label" *ngIf="showLabel">{{ labelText }}<span class="dvm-mandatory-mark" *ngIf="isMandatory" aria-hidden="true">*</span></label>

    <!-- Button/tile mode: every backend option is an always-visible filter button.
         Same `selected` model + onChange path as the ng-select below — only
         the input surface differs. -->
    <div
      *ngIf="isButtonMode"
      class="gd-button-group"
      [class.gd-tiles]="displayMode === 'tiles'"
      [class.gd-disabled]="isDisabled"
    >
      <button
        *ngIf="showAllOption"
        type="button"
        class="gd-option-btn gd-all-btn"
        [class.gd-active]="isAllActive"
        [disabled]="isDisabled"
        (click)="onAllOptionClick()"
      >All</button>
      <!-- topLevelEntries = ungrouped options in original order + one pill per
           configured submenu group (data.optionGroups). A group pill toggles
           its inline submenu row; "All <group>" selects the whole group. -->
      <ng-container *ngFor="let entry of topLevelEntries">
        <button
          *ngIf="entry.kind === 'option'"
          type="button"
          class="gd-option-btn"
          [class.gd-active]="isItemSelected(entry.value)"
          [disabled]="isDisabled"
          [title]="formatOption(entry.value)"
          (click)="onOptionButtonClick(entry.value)"
        >{{ formatOption(entry.value) }}</button>

        <button
          *ngIf="entry.kind === 'group'"
          type="button"
          class="gd-option-btn gd-group-btn"
          [class.gd-active]="isGroupActive(entry)"
          [class.gd-open]="openGroupLabel === entry.label"
          [disabled]="isDisabled"
          [title]="entry.displayLabel || formatOption(entry.label)"
          (click)="onGroupPillClick(entry)"
          (mouseenter)="onGroupPillEnter(entry)"
          (mouseleave)="scheduleSubmenuClose()"
        >{{ entry.displayLabel || formatOption(entry.label) }}<span class="gd-caret" aria-hidden="true">▾</span></button>
      </ng-container>

      <!-- The open group's submenu renders AFTER all top-level pills (not
           inline after its pill): flex-basis:100% mid-row would push the
           remaining pills below the submenu, making them look like part of
           it. This keeps the top row intact with the submenu underneath. -->
      <div
        class="gd-submenu"
        *ngIf="openGroup as g"
        (mouseenter)="cancelSubmenuClose()"
        (mouseleave)="scheduleSubmenuClose()"
      >
        <span class="gd-submenu-caption">{{ g.displayLabel || formatOption(g.label) }}</span>
        <button
          *ngIf="g.showAll !== false"
          type="button"
          class="gd-option-btn gd-all-btn"
          [class.gd-active]="isGroupFullySelected(g)"
          [disabled]="isDisabled"
          (click)="onGroupAllClick(g)"
        >All {{ g.displayLabel || formatOption(g.label) }}</button>
        <button
          *ngFor="let child of g.children"
          type="button"
          class="gd-option-btn"
          [class.gd-active]="isItemSelected(child)"
          [disabled]="isDisabled"
          [title]="formatOption(child)"
          (click)="onOptionButtonClick(child)"
        >{{ formatOption(child) }}</button>
      </div>
    </div>

    <!-- closeOnSelect: a SINGLE-select is finished the moment you pick a value,
         so the panel should close itself. Multi-select stays open so you can
         tick several without reopening it each time. (This was hardcoded false,
         which left single-selects open until you clicked elsewhere.) -->
    <ng-select *ngIf="!isButtonMode" [class.gd-filter-off]="filterSwitchedOff" [attr.title]="filterSwitchedOff ? 'Filter disabled' : null" class="global-dropdown-select" [class.is-open]="isDropdownOpen" appendTo="body" ngClass="ss-dropdown-panel" [items]="filteredOptions" [multiple]="data?.isMultiSelect" [closeOnSelect]="!data?.isMultiSelect" [(ngModel)]="selected"
      [searchable]="false" [clearable]="!isDisabled && allowsEmptySelection" [disabled]="isDisabled" [placeholder]="placeholderText" (change)="onChange($event)" (open)="onDropdownOpen()" (close)="onDropdownClose()">
      <ng-template ng-header-tmp>
        <div class="custom-header">
          <div class="custom-option" *ngIf="showAllOption" [class.gd-active]="isAllActive" (click)="onAllOptionClick()">
            All
          </div>
          <!-- Search input -->
          <div class="search-wrapper">
            <!-- <mat-icon class="search-icon" fontIcon="search"></mat-icon> -->
            <input type="text" class="search-input" placeholder="Search" [formControl]="searchCtrl" (keydown)="$event.stopPropagation()"/>
          </div>


        <div class="custom-option" *ngIf="data?.isMultiSelect">
          <input type="checkbox" id="select-all" [checked]="isAllSelected" (change)="toggleSelectAll($event)" />
          <label for="select-all">&nbsp;Select All</label>
        </div>
      </div>
    </ng-template>

    <!-- Closed-control label (single-select). REQUIRED, not cosmetic: our options
         are plain strings, and ng-select derives its own label via
         resolveNested(item, bindLabel) with bindLabel defaulting to 'label' —
         "73022.02".label is undefined, so its built-in label renders as an empty
         chip. Printing the raw value ourselves is what makes the selection
         visible. (Multi-select is covered by ng-multi-label-tmp below.) -->
    <ng-template ng-label-tmp let-item="item">
      <span class="ng-value-label">{{ formatOption(item) }}</span>
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index">
      <div [title]="formatOption(item)" (click)="onItemClick(item)">
        <input id="item-{{ index }}" type="checkbox" [checked]="isItemSelected(item)" [matTooltip]="formatOption(item)"
          matTooltipPosition="right" />
        {{ formatOption(item) }}
      </div>
    </ng-template>

    <!-- Closed-control chip (multi-select). No per-chip "×": the control's own
         clear button (right side, .ng-clear-wrapper) is the single way to
         clear, so the box never shows two crosses. The chip is styled flat
         (no theme-blue pill) and vertically centred — see the
         .custom-multi-label-wrapper / .ng-value overrides in the SCSS. -->
    <ng-template ng-multi-label-tmp let-items="items">
      <div class="custom-multi-label-wrapper">
        <ng-container *ngIf="items?.length > 0">
          <div class="ng-value">
            <span class="ng-value-label">
              {{ formatOption(items[0]) }}
            </span>
          </div>
        </ng-container>
        <span class="tag-summary" *ngIf="items?.length > 1">
          +{{ items.length - 1 }} more
        </span>
      </div>
    </ng-template>

  </ng-select>
</div>
